export enum CallStatusType {
    WAITING_FOR_REMOTE = 'WAITING_FOR_REMOTE',
    CALL_STARTED = 'CALL_STARTED',
    CALL_STARTING = 'CALL_STARTING',
    CALL_ERROR = 'CALL_ERROR',
    REMOTE_PREPARING = 'REMOTE_PREPARING',
    REMOTE_LEFT = 'REMOTE_LEFT',
    REMOTE_DEVICE_ISSUES = 'REMOTE_DEVICE_ISSUES',
    REMOTE_MUTED_DEVICES = 'REMOTE_MUTED_DEVICES',
    REMOTE_CONNECTING = 'REMOTE_CONNECTING',
    REMOTE_WAITING = 'REMOTE_WAITING',
}
